import { css } from "lit";
import { APP_CONFIG } from "../config/attributes";
import { customLightThemeVars, customDarkThemeVars } from "./themes-custom";

/**
 * Default light theme variable definitions.
 */
const defaultLightThemeVars = css`
  --bab-bg: #f0f4f8;
  --bab-card-bg: #ffffff;
  --bab-text: #1a1a2e;
  --bab-text-secondary: #646b78;
  --bab-border: #e5e7eb;
  --bab-accent: #4a90e2;
  --bab-banner-bg: #fffbeb;
  --bab-banner-text: #92400e;
  --bab-banner-border: #fcd34d;
  --bab-input-bg: #ffffff;
  --bab-input-text: #111827;
  --bab-button-secondary-bg: #ffffff;
  --bab-button-secondary-text: #396acc;
  --bab-delta-pos: #166534;
  --bab-delta-pos-bg: #dcfce7;
  --bab-delta-neg: #991b1b;
  --bab-delta-neg-bg: #fee2e2;

  /* Structural Defaults */
  --bab-border-width: 1.5px;
  --bab-radius: 12px;
  --bab-font-weight: 600;
`;

/**
 * Default dark theme variable definitions.
 */
const defaultDarkThemeVars = css`
  --bab-bg: #0f172a;
  --bab-card-bg: #1e293b;
  --bab-text: #f8fafc;
  --bab-text-secondary: #94a3b8;
  --bab-border: #334155;
  --bab-accent: #38bdf8;
  --bab-banner-bg: #1e1b16;
  --bab-banner-text: #fbbf24;
  --bab-banner-border: #451a03;
  --bab-input-bg: #0f172a;
  --bab-input-text: #f8fafc;
  --bab-button-secondary-bg: #1e293b;
  --bab-button-secondary-text: #38bdf8;
  --bab-delta-pos: #4ade80;
  --bab-delta-pos-bg: rgba(74, 222, 128, 0.12);
  --bab-delta-neg: #fca5a5;
  --bab-delta-neg-bg: rgba(252, 165, 165, 0.12);

  /* Structural Defaults */
  --bab-border-width: 1.5px;
  --bab-radius: 12px;
  --bab-font-weight: 600;
`;

const isCustom = APP_CONFIG.themeSet === "custom";
const lightThemeVars = isCustom ? customLightThemeVars : defaultLightThemeVars;
const darkThemeVars = isCustom ? customDarkThemeVars : defaultDarkThemeVars;

/**
 * Shared theme variables.
 */
export const themeStyles = css`
  :host {
    ${lightThemeVars}
    background: var(--bab-bg);
    color: var(--bab-text);
  }

  :host([data-theme="dark"]) {
    ${darkThemeVars}
  }

  @media (prefers-color-scheme: dark) {
    :host([data-theme="system"]) {
      ${darkThemeVars}
    }
  }
`;
